import * as R from "org/risks/types";
import { Guid } from "utils/guid";

import * as T from "./types";

function isConditionTrue(
    fieldId: Guid,
    condition: R.Condition,
    dependencyInstance: T.MetadataInstance
): boolean {
    if (condition.value === undefined) {
        // XXX I am not sure that is actually reachable. In the doubt, I keep the check.
        return false;
    }
    let valueFound = false;
    switch (dependencyInstance.type) {
        case "CheckboxGroupInstance": {
            const { value } = dependencyInstance;
            if (value && value.some((opt) => opt.id === condition.value)) {
                valueFound = true;
            }
            break;
        }
        case "RadioButtonGroupInstance":
        case "DropdownInstance": {
            const { value } = dependencyInstance;
            if (value !== undefined && value.id === condition.value) {
                valueFound = true;
            }
            break;
        }
        case "MetadataError":
            // We should not be in this case, because the only way we can get MetadataError is when a formula
            // returns NaN or ±Infinity, and formulas may not be used in conditions
            console.error(
                "A condition used in a column has a formula with an error"
            );
            return false;
        default:
            throw new Error(
                `Field '${fieldId}' cannot depend on field of type '${dependencyInstance.fieldType.type}'`
            );
    }
    const result =
        (valueFound && condition.operator === "Equal") ||
        (!valueFound && condition.operator === "NotEqual");
    return result;
}

export { isConditionTrue };
